import { render, staticRenderFns } from "./safeGrade.vue?vue&type=template&id=85e0e268&"
import script from "./safeGrade.vue?vue&type=script&lang=js&"
export * from "./safeGrade.vue?vue&type=script&lang=js&"
import style0 from "./safeGrade.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports